'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeForwardArrowEvent = composeForwardArrowEvent;
exports.composeBackwardArrowEvent = composeBackwardArrowEvent;
exports.composeDotEvent = composeDotEvent;
exports.composeAllResultsEvent = composeAllResultsEvent;
exports.composeTitleEvent = composeTitleEvent;
exports.composeCoverArtEvent = composeCoverArtEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    LABELS = _constantsAnalytics2.default.LABELS,
    CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS;


function composeCarouselEvent(_ref) {
  var gtmAction = _ref.gtmAction,
      gtmLabel = _ref.gtmLabel,
      _ref$gtmValue = _ref.gtmValue,
      gtmValue = _ref$gtmValue === undefined ? 1 : _ref$gtmValue,
      gtmContainerName = _ref.gtmContainerName,
      gtmContentType = _ref.gtmContentType,
      payload = _objectWithoutProperties(_ref, ['gtmAction', 'gtmLabel', 'gtmValue', 'gtmContainerName', 'gtmContentType']);

  return (0, _compose.composeEvent)(EVENTS.CAROUSEL_INTERACTION, _extends({
    gtmCategory: CATEGORIES.CAROUSELS,
    gtmAction: gtmAction,
    gtmLabel: gtmLabel,
    gtmValue: gtmValue,
    gtmContainerName: gtmContainerName,
    gtmContentType: gtmContentType
  }, payload));
}

function composeForwardArrowEvent(payload) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(_extends({
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: LABELS.CONTAINER_FWD_ARROW
  }, payload))]);
}

function composeBackwardArrowEvent(payload) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(_extends({
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: LABELS.CONTAINER_BWD_ARROW
  }, payload))]);
}

function composeDotEvent(payload) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(_extends({
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: LABELS.CONTAINER_DOT_INDICATORS
  }, payload))]);
}

function composeAllResultsEvent(gtmContainerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent({
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: LABELS.CONTAINER_VIEW_ALL,
    gtmContainerName: gtmContainerName
  })]);
}

function composeTitleEvent(payload) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(_extends({
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: LABELS.CONTAINER_TITLE
  }, payload))]);
}

function composeCoverArtEvent(gtmContainerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent({
    gtmAction: ACTIONS.CLICK_IMAGE,
    gtmLabel: LABELS.BIB_IMAGE,
    gtmContainerName: gtmContainerName,
    gtmContentType: CUSTOM_DIMENSIONS.CONTENT_TYPES.BIB
  })]);
}

exports.default = {
  composeForwardArrowEvent: composeForwardArrowEvent,
  composeBackwardArrowEvent: composeBackwardArrowEvent,
  composeDotEvent: composeDotEvent,
  composeAllResultsEvent: composeAllResultsEvent,
  composeTitleEvent: composeTitleEvent,
  composeCoverArtEvent: composeCoverArtEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/carouselEventComposer.js
// module id = 576
// module chunks = 0 2 4 5 6 8 9 10 11